module.exports = __webpack_public_path__ + "img/office-screen-03.489cbe41.jpg";